import {
  HttpErrorResponse,
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
  HttpResponse,
} from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Router } from "@angular/router";
import { Observable, throwError } from "rxjs";
import { catchError, tap } from "rxjs/operators";
import { NotificationService } from "src/app/shared/isolutions-ui/feedback/notifications/notification.service";
import { AuthService } from "../services/auth.service";

/**
 * ErrorInterceptor — intercepta respostas HTTP e exibe mensagens do backend.
 *
 * Regras:
 * - NUNCA exibe mensagem mockada/hardcoded
 * - Sempre usa messageDescription retornada pelo backend
 * - 401 → logout + redirect para login
 * - Outros erros → exibe mensagem do backend via toastr
 */
@Injectable()
export class ErrorInterceptor implements HttpInterceptor {
  constructor(
    private authService: AuthService,
    private router: Router,
    private notify: NotificationService,
  ) {}

  intercept(
    request: HttpRequest<any>,
    next: HttpHandler,
  ): Observable<HttpEvent<any>> {
    return next.handle(request).pipe(
      tap((event) => {
        if (event instanceof HttpResponse && event.body) {
          const body = event.body;

          // Backend retornou 200 mas com statusCode 401 no body
          if (body.statusCode === 401) {
            this.authService.logout();
            this.router.navigate(["/account/login"], {
              queryParams: { message: body.messageCode },
            });
          }
        }
      }),
      catchError((err: HttpErrorResponse) => {
        if (err.status === 401) {
          this.authService.logout();
          this.router.navigate(["/account/login"]);
          return throwError(() => err);
        }

        // Mensagem SEMPRE vem do backend
        const backendMessage =
          err.error?.messageDescription || err.error?.message || err.message;

        if (backendMessage) {
          this.notify.error(backendMessage);
        }

        return throwError(() => backendMessage);
      }),
    );
  }
}
